import {Link} from 'gatsby'
import React from 'react'
import ArticlePreview from './article-preview'
import styled from 'styled-components'

import Reveal from 'react-reveal/Reveal';

const ArticleGrid = styled.article`

  display: grid;
  grid-template-columns: minmax(30px, 60px) 1fr minmax(30px, 60px);

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;

    grid-column: 2;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 30px;

    li:nth-child(even) {
    }

    li:nth-child(3) {
      img {}
    }
  }

  a {
    color: black;
    text-decoration: none;
  }
`

function ArticlePreviewGrid (props) {
  return (
    <ArticleGrid>
      <ul>
        {props.nodes &&
          props.nodes.map(node => (
            <Reveal>
            <li key={node.id}>
              <ArticlePreview {...node} />
            </li>
            </Reveal>
          ))}
      </ul>
      {props.browseMoreHref && (
        <div >
          <Link to={props.browseMoreHref}>Browse more</Link>
        </div>
      )}
    </ArticleGrid>
  )
}

ArticlePreviewGrid.defaultProps = {
  title: '',
  nodes: [],
  browseMoreHref: ''
}

export default ArticlePreviewGrid
